import { __assign } from "tslib";
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { DropdownList } from '../dropdown-list/dropdown-list';
import { DropdownSearchTrigger } from './dropdown-search-trigger';
import classNames from 'classnames';
import styles from './dropdown-search.module.css';
import { search } from '../../../../library';
import { noResultsItems } from '../dropdowns.helpers';
function generateInitialItems(items) {
    return items.map(function (item) { return (__assign({}, item)); });
}
function generateCurrentItems(items, query) {
    var nextItems = !!query ? search(items, query, 'label', 'value') : items.map(function (item) { return (__assign({}, item)); });
    return !nextItems.length ? noResultsItems : nextItems;
}
function generateSelectedItems(items) {
    return items.filter(function (item) { return item.selected; });
}
function generateValue(selectedItems) {
    return !selectedItems.length ? '' : selectedItems[0].label || selectedItems[0].value;
}
export var DropdownSearch = React.forwardRef(function (props, outerRef) {
    var 
    // html props
    id = props.id, name = props.name, disabled = props.disabled, multiple = props.multiple, 
    // custom props
    label = props.label, items = props.items, validation = props.validation, large = props.large, responsive = props.responsive, dialogContained = props.dialogContained;
    var cleansedProps = __assign(__assign({}, props), { 
        // html props
        disabled: disabled !== null && disabled !== void 0 ? disabled : false, multiple: multiple !== null && multiple !== void 0 ? multiple : false, 
        // custom props
        label: label, items: items, validation: validation, large: large });
    var innerRef = useRef(null);
    useImperativeHandle(outerRef, function () { return innerRef.current; }, []);
    var _a = useState(generateInitialItems(items)), initialItems = _a[0], setInitialItems = _a[1];
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var _c = useState(generateCurrentItems(initialItems, value)), currentItems = _c[0], setCurrentItems = _c[1];
    var _d = useState(generateSelectedItems(initialItems)), selectedItems = _d[0], setSelectedItems = _d[1];
    var _e = useState(false), isOpen = _e[0], setIsOpen = _e[1];
    /* Generate initial, current and selected items whenever items changes */
    useEffect(function () {
        var nextItems = generateInitialItems(items);
        setInitialItems(nextItems);
        setCurrentItems(generateCurrentItems(nextItems, value));
        setSelectedItems(generateSelectedItems(nextItems));
    }, [items]);
    /* Set query value when <DropdownList> opens/closes */
    useEffect(function () {
        isOpen ? setValue('') : setValue(generateValue(selectedItems));
    }, [isOpen]);
    /* Set query value whenever selected items changes once <DropdownList> has closed */
    useEffect(function () {
        if (isOpen)
            return;
        setValue(generateValue(selectedItems));
    }, [selectedItems]);
    /* Generate current items whenever query changes */
    useEffect(function () {
        setCurrentItems(generateCurrentItems(initialItems, value));
    }, [value]);
    // TODO: FieldController
    // useEffect(() => {
    //   if (!!onChange) {
    //     const event = { target: { value: multiple ? selectedItems.map(selectedItem => selectedItem.value) : (selectedItems[0]?.value ?? '') } } as React.ChangeEvent<HTMLSelectElement>;
    //     console.log('event', event.target.value);
    //     onChange(event);
    //   }
    // }, [selectedItems]);
    // useEffect(() => {
    //   if (!!props.value) return currentItems.find(item => item.value === props.value)?.onClick();
    //   if (!!props.defaultValue) return currentItems.find(item => item.value === props.defaultValue)?.onClick();
    // }, [props.defaultValue, props.value]);
    return (React.createElement("div", { className: classNames('fieldValidationWrapper', { responsive: responsive }), style: { zIndex: isOpen ? 99999 : 'auto' } },
        React.createElement(DropdownList, { items: currentItems, selectedItems: selectedItems, large: large, multiple: multiple, dialogContained: dialogContained }, function (_a) {
            var _b;
            var _c;
            var triggerRef = _a.triggerRef, open = _a.open, onOpenHandler = _a.onOpenHandler, onCloseHandler = _a.onCloseHandler, bottomQuadrant = _a.bottomQuadrant;
            return (React.createElement("div", { ref: triggerRef, className: classNames('inputWrapper text', [styles.dropdownSearchWrapper], (_b = {
                        populated: !!selectedItems.length || !!value,
                        validation: (validation === null || validation === void 0 ? void 0 : validation.dirty) && (validation === null || validation === void 0 ? void 0 : validation.invalid),
                        disabled: disabled,
                        large: large,
                        responsive: responsive,
                        prefix: !open && !!((_c = selectedItems[0]) === null || _c === void 0 ? void 0 : _c.icon)
                    },
                    _b[styles.large] = large,
                    _b[styles.bottomQuadrant] = bottomQuadrant,
                    _b)) },
                React.createElement(DropdownSearchTrigger, __assign({}, cleansedProps, { selectedItems: selectedItems, bottomQuadrant: bottomQuadrant, open: open, onFocus: function () {
                        onOpenHandler();
                        setIsOpen(true);
                    }, onBlur: function () {
                        onCloseHandler();
                        setIsOpen(false);
                    }, onInput: setValue, value: value }))));
        }),
        !!validation && (React.createElement("div", { className: classNames('fieldValidation fieldErrorMessage', { invisible: !validation.dirty || !validation.invalid }) }, validation.message))));
});
DropdownSearch.displayName = 'DropdownSearch';
export default DropdownSearch;
